import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from "rxjs";
import { environment } from '../../../../environments/environment';
const _ = require('lodash');

@Injectable({
  providedIn: 'root'
})
export class ArticleGroupService {
  private SERVER_URL = `${environment.API_URL}`;

  constructor(private httpClient: HttpClient) { }

  public saveArticleGroup(data: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-groups-articles/companyArticleGroups/saveArticleGroup',
        { data },
        { headers });
  }

  public updateArticleGroup(data: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-groups-articles/companyArticleGroups/updateArticleGroup',
        { data },
        { headers });
  }

  public getArticleGroups(gestiuneId: number | null = null): Observable<any> {
    const options = gestiuneId === null ? {} : { params: { id: gestiuneId.toString() } };

    return this.httpClient.get<any>(
      this.SERVER_URL + 'company-groups-articles/companyArticleGroups/getArticleGroups',
      options
    );
  }

  public deleteArticleGroup(id: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-groups-articles/companyArticleGroups/deleteArticleGroup',
        { id },
        { headers });
  }
}